import { NativeApp, NativeAppType } from "./";

// If the user is in a browser and not iOS or Android, don't do anything when these events are triggered
export default class Noop implements NativeApp {
  readonly type = NativeAppType.None;
  readonly isMobile = false;

  register() {
    console.debug("NATIVE APP: Registering");
  }

  scanBarcode() {
    console.debug("NATIVE APP: Scanning Barcode");
    return Promise.resolve("");
  }

  navigateToEditServer(): void {
    console.debug("NATIVE APP: Navigating to Edit Server");
  }
}
